var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExchange2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1392,
    cy: 34.1692,
    r: 34,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_208_774",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0354 17.2729H17.2427V51.0657H51.0354V17.2729Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_208_774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2826 20.5114L50.472 38.3934L43.9951 47.968L17.8057 29.9452L24.2826 20.5114Z",
    fill: "url(#paint0_linear_208_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4719 38.3935C48.219 41.6319 40.6157 40.3647 33.4347 35.2958C26.1129 30.3677 22.1705 23.7499 24.2825 20.5114C26.5354 17.273 34.1387 18.5402 41.3197 23.6091C48.6415 28.3964 52.5839 35.155 50.4719 38.3935Z",
    fill: "url(#paint1_linear_208_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9951 47.8272C41.7422 51.0657 34.1389 49.7985 26.9579 44.7296C19.7769 39.6606 15.6936 33.1837 17.9465 29.8044C20.1993 26.5659 27.8027 27.8332 34.9837 32.9021C42.1647 37.971 46.1071 44.5888 43.9951 47.8272Z",
    fill: "url(#paint2_linear_208_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.472 38.3934L43.9951 47.968C41.7422 51.2065 34.1388 49.7985 26.9579 44.8704C25.5498 43.8847 24.2826 42.8991 23.0154 41.7727C24.001 41.6319 25.2682 41.0687 26.5355 39.6606C28.7883 37.267 29.9147 36.7038 30.9004 36.8446C31.886 36.8446 33.0124 37.8302 34.8429 40.2239C36.6733 42.6175 39.2078 43.3215 40.7566 42.0543C40.8974 41.9135 41.0382 41.9135 41.179 41.7727C42.4462 40.7871 42.8686 40.3647 45.2623 35.859C45.8255 34.7325 47.7967 32.9021 50.472 33.7469C51.176 35.5774 51.176 37.1262 50.472 38.3934Z",
    fill: "#0E0F23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4863 37.8303C47.5151 40.6464 40.6157 39.2383 33.998 34.5918C27.2394 29.9453 23.2969 24.0316 25.2682 21.2155C27.2394 18.3995 34.1388 19.8075 40.7565 24.454C47.3743 29.1005 51.3168 35.0142 49.4863 37.8303ZM43.291 33.6062C42.3054 35.0142 38.9261 34.3102 35.5468 32.0574C32.3084 29.8045 30.3371 26.8477 31.3227 25.4396C32.3084 24.0316 35.6876 24.7356 39.0669 26.9885C42.3054 29.2413 44.2766 32.1982 43.291 33.6062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7195 23.7499C23.7195 23.6091 23.5787 23.4683 23.4379 23.6091C23.2971 23.7499 23.1562 23.7499 23.1562 23.8907C23.2971 24.3131 23.4379 24.5947 23.4379 24.8763C23.4379 25.0171 23.5787 25.1579 23.7195 25.0171C23.8603 25.0171 24.0011 24.8763 23.8603 24.7355C23.8603 24.4539 23.8603 24.1723 23.7195 23.7499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4231 26.0028C24.4231 25.862 24.2823 25.7212 24.1415 25.862C24.0007 26.0028 24.0007 26.0028 24.0007 26.1436C25.5496 29.6637 28.788 33.4654 33.0121 36.2815C33.1529 36.4223 33.2937 36.2815 33.4345 36.2815C33.5754 36.1407 33.4345 35.9999 33.4345 35.8591C29.0696 33.043 25.972 29.3821 24.4231 26.0028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4608 39.8015C41.32 39.8015 41.1792 39.8015 41.1792 39.9423C41.1792 40.0831 41.1792 40.2239 41.32 40.2239C41.7424 40.3647 42.3056 40.5055 42.728 40.6463C42.8688 40.6463 43.0096 40.6463 43.0096 40.5055C43.0096 40.3647 43.0096 40.2239 42.8688 40.2239C42.4464 40.0831 41.8832 39.9423 41.4608 39.8015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.995 40.3647C43.8542 40.3647 43.7134 40.5056 43.7134 40.6464C43.7134 40.7872 43.8542 40.928 43.995 40.928C45.1214 41.0688 46.3886 41.2096 47.3743 41.0688C47.5151 41.0688 47.6559 40.928 47.6559 40.7872C47.6559 40.6464 47.5151 40.5055 47.3743 40.5055C46.2478 40.6464 45.1214 40.5055 43.995 40.3647Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_774",
    x1: 29.4138,
    y1: 17.9689,
    x2: 34.6074,
    y2: 35.8033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_208_774",
    x1: 33.6907,
    y1: 16.7233,
    x2: 38.8845,
    y2: 34.5578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_208_774",
    x1: 25.15,
    y1: 19.2105,
    x2: 30.3438,
    y2: 37.0451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange2);
export default __webpack_public_path__ + "static/media/exchange2.e58a735c36b1ddf5c70324379f09a42f.svg";
export { ForwardRef as ReactComponent };